<template>
    <div class="coupon_content">
        <div class="coupon_title_content"><h3>领取优惠券</h3></div>
        <div class="coupon_list_content">
            <ul>
                <li v-for="(item, index) in couponlist" :key="index">
                    <div class="coupon_list_main" @click="getCouponinfo(item)">
                        <div class="coupon_list_left">
                            <span>¥{{item.cost}}</span>
                            <small v-if="item.limittype == 2">满{{item.limitcost}}元可用</small>
                            <small v-else>无限制</small>
                        </div>
                        <div class="coupon_list_right">
                            <div class="coupon_list_name"><h3>{{item.name}}</h3></div>
                            <div class="coupon_list_label">
                                <span v-for="(j, sign) in item.goodsrangevalue" :key="sign" v-if="sign < 5">{{j}}</span>
                                <span style="cursor: pointer" v-if="item.goodsrangevalue.length > 5">更多</span>
                            </div>
                            <div class="coupon_list_time"><span>使用时间：{{item.sdatex}}<small v-if="item.sdatex != ''">-</small>{{item.edatex}}</span></div>
                            <div class="coupon_list_explain"><span>使用说明：{{item.instructions}}</span><i class="icon iconfont icon-icon_zhankai_xiangxia1" v-if="item.instructions != ''"></i></div>
                        </div>
                    </div>
                    <div class="coupon_list_btn">
                        <span class="receive" @click="couponBtn(1, item.id)" v-if="item.canget > 0">立即领取</span>
                        <span class="use" @click="couponBtn(2)" v-else>去使用</span>
                        <small>剩余{{item.yucount}}张</small>
                    </div>
                </li>
            </ul>
        </div>
        <SeeCoupon :couponShow="couponShow" :couponinfo="couponinfo" @couponCancel="couponCancel"></SeeCoupon>
        <noLoginTips :nologinShow="nologinShow" :nologintipsmsg="nologintipsmsg" @nologinOk="nologinOk" @nologinCancel="nologinCancel"></noLoginTips>
    </div>
</template>

<script>
import api from '@/request/api.js'
import SeeCoupon from '@/components/component/popup/seecoupon.vue'
import noLoginTips from '@/components/component/popup/nologintips.vue'
export default {
    components: {SeeCoupon, noLoginTips},
    data() {
        return {
            couponShow: false, // 查看优惠券信息弹窗
            couponlist: [], // 优惠券列表
            couponinfo: {}, // 点击选中优惠券信息
            nologinShow: false, // 未登录弹窗是否显示
            nologintipsmsg: false, // 未登录弹窗信息
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.http.post(api.couponlist)
            .then(response => {
                console.log(response.data.msg)
                this.couponlist = response.data.msg.datalist
            })
            .catch(error => {
                console.log(error);
            })
        },
        getcoupon (id) { // 领取优惠券
            if (!this.$store.state.openmall) {
                this.http.post(api.getcoupon, {couponid: id})
                .then(response => {
                    console.log(response.data.msg)
                    if (!response.data.error) {
                        this.$Message.success('优惠券领取成功')
                        this.getInfo()
                    } else {
                        this.$Message.warning(response.data.msg)
                    }
                })
                .catch(error => {
                    this.$Message.error(error)
                })
            } else {
                this.nologintipsmsg = '未登录客户不可领取，请登录'
                this.nologinShow = true
            }
        },
        couponBtn (sign, id) { // 去使用按钮
            if (sign == 1) {
                this.getcoupon(id)
            } else {
                this.$router.push({
                    name: "商品",
                    params: {
                        type: 0
                    }
                })
            }
        },
        getCouponinfo (item) { // 点击获取当前优惠券信息
            this.couponinfo = item
            this.couponShow = true
        },
        couponCancel () { // 关闭查看优惠券信息弹窗
            this.couponShow = false
        },
        nologinOk () {
            this.nologinShow = false
        },
        nologinCancel () {
            this.nologinShow = false
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/coupon/coupon.vue